import useFirebase from "../../../../../useFirebase";

function useSosSetting(device, sosState, setSosState) {
  const { getCollectionData, postCollectionData, createCollectionData } =
    useFirebase();

  function callFireStore(payload) {
    postCollectionData(device, { sossettings: payload });
    getCollectionData(device);
  }

  function createCollectionStore(payload) {
    createCollectionData(device, { sossettings: payload });
    getCollectionData(device);
  }

  function handleSaveData(data) {
    callFireStore(data);
  }

  return { handleSaveData };
}

export default useSosSetting;
